import { paths } from '@omnea-digital/audit-log-client'
import { GenericQuery, GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'

interface Params {
  authorization: string
}

export class AuditLogApiClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.AUDIT_LOG,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type AuditLogRequest<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
export type AuditLogResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type AuditLogQueryParams<T extends keyof paths, T2 extends keyof paths[T]> = GenericQuery<paths, T, T2>
